import { FC } from 'react';

type MailIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MailIcon: FC<MailIconProps> = ({
  width = 16,
  height = 16,
  color = '#BB9583',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M1.3335 4L5.94218 6.61131C7.64123 7.574 8.3591 7.574 10.0582 6.61131L14.6668 4" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M1.34401 8.98374C1.38759 11.0275 1.40938 12.0493 2.16347 12.8063C2.91755 13.5632 3.96705 13.5895 6.06605 13.6423C7.3597 13.6748 8.64063 13.6748 9.9343 13.6423C12.0333 13.5895 13.0828 13.5632 13.8369 12.8063C14.591 12.0493 14.6128 11.0275 14.6563 8.98374C14.6704 8.32661 14.6704 7.67341 14.6563 7.01628C14.6128 4.97258 14.591 3.95074 13.8369 3.19378C13.0828 2.43683 12.0333 2.41046 9.9343 2.35772C8.64063 2.32522 7.3597 2.32522 6.06604 2.35772C3.96705 2.41045 2.91755 2.43682 2.16346 3.19378C1.40938 3.95073 1.38759 4.97258 1.344 7.01628C1.32999 7.67341 1.33 8.32661 1.34401 8.98374Z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

